<template>
    <div class="share-c">
        <div class="save" @click="toShare('save')">长按图片保存</div>
        <div class="cancel" @click="handleCancle">取消</div>
    </div>
</template>
<script>
    import Supporter from '../../utils/supporter';
    import ShareSns from 'common-components/lib/shareJs/index';

    const isWeixin = Supporter.isWeixin

    export default {
        data() {
            return {
                shareSnsInstance: '',
                shareTo: 'wechattimeline',
            }
        },
        mounted() {
            window.eventBus.$on('updatePosterImg',this.init)
        },
        methods: {
            handleCancle() {
                this.$emit('closeShareMask')
            },
            init(imgData) {
                const articleShareData = {
                    image: imgData,
                    failCallback: this.shareFailDialog,
                    completeCallback: this.completeCallback,
                }
                if (!this.shareSnsInstance) {
                    this.shareSnsInstance = new ShareSns(
                        articleShareData,
                        document.querySelector('.share-container')
                    )
                    this.shareSnsInstance.init({
                        isNeedCheckShareByQQBrowser: false,
                        isWeixin: isWeixin,
                    })
                } else {
                    this.shareSnsInstance.update(articleShareData)
                }
            }, 
            // 失败回调
            shareFailDialog(app){ 
                this.toShare('save')
            },
            completeCallback(){},
            toShare(app) {
                window?.sohuSpm?.sendAction({
                    acode: 10528,
                    clkParam: 'shareCode:bcbd'
                })
                if(app == 'save') {
                    this.$emit("handleShowToast")
                    return
                }
                this.shareSnsInstance.shareto(app)
            },
        }
    }
</script>
<style lang="less" scoped>
   .share-c {
        width: 100%;
        .save {
            height: 108px;/*px*/
            background: #FFFFFF;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 32px;/*px*/
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3C3C3D;
            border-bottom: 1px #F4F5F6 solid;
        }
        .cancel {
            width: 100%;
            height: 108px;/*px*/
            background: #FFFFFF;
            font-size: 32px;/*px*/
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3C3C3D;
            line-height: 108px;/*px*/
            text-align: center;
        }
    }
</style>